import React, { useEffect } from 'react'
import { Col, Row } from 'antd'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const profileLinks = [
	{
		name: 'Profile',
		href: '/teacher/dashboard/profile'
	},
	{
		name: 'Avatar',
		href: '/teacher/dashboard/profile/avatar'
	},
	{
		name: 'Teachers',
		href: '/teacher/dashboard/profile/teachers'
	},
	{
		name: 'Tutor',
		href: '/teacher/dashboard/profile/tutor'
	},
	{
		name: 'Statistics',
		href: '/teacher/dashboard/profile/statistics'
	},
	// {
	// 	name: 'Friends',
	// 	href: '/student/dashboard/profile/friends'
	// },
	// {
	// 	name: 'Leaderboard',
	// 	href: '/student/dashboard/profile/leaderboard'
	// },
]

const Teacherprofile = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()


	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Profile'
			}
		})

		// eslint-disable-next-line
	}, [])


	return (
		<>
			<div className='h-screen pr-10 mt-4 mb-10'>
				<Row gutter={16}>
					<Col xs={24} md={24} lg={4}>
						<div className='flex flex-col w-full'>
							{
								profileLinks.map((item) => (
									<a href={item.href}
										key={`profile-nav-${item.name}`}
										rel="noopener noreferrer"
										onClick={(e) => {
											e.preventDefault()
											navigate(item.href, {
												state: {
													pageName: 'Profile'
												}
											})
										}}
										className={`${pathname === item.href ? 'bg-appcolorpurplefaint font-semibold ' : ''} 
                    hover:bg-appcolorpurplefaint hover:font-semibold 
                    text-appcolorblack text-base py-5 px-6 w-full rounded-[10px] mb-4`}
									>
										{item.name}
									</a>
								))
							}
						</div>
					</Col>
					<Col xs={24} md={24} lg={20}>
						<Outlet />
					</Col>
				</Row>
			</div>
		</>
	)
}

export default Teacherprofile